// extracted by mini-css-extract-plugin
export var cancelButton = "_nz-5";
export var content = "_nz-3";
export var createButton = "_nz-6";
export var drawerContainer = "_nz-0";
export var footer = "_nz-2";
export var header = "_nz-1";
export var orderFormColumn = "_nz-4";